import React from 'react'
import { Form, Transition } from 'semantic-ui-react'
import { ANIMATION_DURATION, ExecutionAlgoOptions, MarketOptions, RouteTypeOptionsApexTrade } from '../constants'
import { CounterPartyDetailsProps } from '../CounterPartyDetails'
import { getError } from '../helpers'
import { RouteTypeEnum } from '../Types'

const ApexTradeFields = ({ setFieldValue, values, handleBlur, errors, touched }: CounterPartyDetailsProps) => (
  <div className={'test-apex-trade-fields'}>
    <Form.Group widths="5">
      <Form.Select
        className={'test-route-type'}
        selection={true}
        required={true}
        label="Route Type"
        name="routeType"
        value={values.routeType}
        options={RouteTypeOptionsApexTrade}
        error={getError('routeType', errors, touched)}
        onChange={(_, data) => {
          setFieldValue('routeType', data.value)
        }}
        onBlur={() => {
          handleBlur('routeType')
        }}
      />
      <Form.Input
        className={'test-order-id'}
        label="Order ID"
        name="orderId"
        value={values.orderId}
        onChange={(_, data) => {
          setFieldValue('orderId', data.value)
        }}
        onBlur={() => {
          handleBlur('orderId')
        }}
        error={getError('orderId', errors, touched)}
      />
    </Form.Group>
    <Transition.Group animation={'fade down'} duration={ANIMATION_DURATION}>
      {values.routeType === RouteTypeEnum.Algo && (
        <Form.Group widths="5">
          <Form.Select
            className={'test-exec-algo'}
            selection={true}
            search={true}
            label="Execution Algorithm"
            name="executionAlgorithm"
            value={values.executionAlgorithm}
            options={ExecutionAlgoOptions}
            required
            onChange={(_, data) => {
              setFieldValue('executionAlgorithm', data.value)
            }}
            onBlur={() => {
              handleBlur('executionAlgorithm')
            }}
            error={getError('executionAlgorithm', errors, touched)}
          />
        </Form.Group>
      )}
    </Transition.Group>
    <Transition.Group animation={'fade down'} duration={ANIMATION_DURATION}>
      {values.routeType === RouteTypeEnum.Dma && (
        <Form.Group widths="5">
          <Form.Select
            className={'test-market'}
            selection={true}
            search={true}
            label="Market"
            name="market"
            required
            options={MarketOptions}
            value={values.market}
            onChange={(_, data) => {
              setFieldValue('market', data.value)
            }}
          />
        </Form.Group>
      )}
    </Transition.Group>
  </div>
)

export default ApexTradeFields
